import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./SectionsAndCoursesUIHelpers";

const SectionsAndCoursesUIContext = createContext();

export function useSectionsAndCoursesUIContext() {
  return useContext(SectionsAndCoursesUIContext);
}

export const SectionsAndCoursesUIConsumer = SectionsAndCoursesUIContext.Consumer;

export function SectionsAndCoursesUIProvider({ children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams
  };

  return (
    <SectionsAndCoursesUIContext.Provider value={value}>
      {children}
    </SectionsAndCoursesUIContext.Provider>
  );
}